"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _CustomJSActions = require("../actions/CustomJSActions");

var _handleActions;

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _CustomJSActions.REQUESTED_CUSTOM_JS, function (state) {
  return state.set('loading', true);
}), (0, _defineProperty2.default)(_handleActions, _CustomJSActions.RECEIVED_CUSTOM_JS, function (state, _ref) {
  var payload = _ref.payload;
  return state.set('scripts', payload.scripts).set('loading', false);
}), _handleActions), (0, _immutable.Map)({
  scripts: [],
  loading: false
}));

exports.default = _default;
module.exports = exports.default;